__webpack_require__.p = "https://staging-admin.kliik.je/";